import {
  createContext,
  type Dispatch,
  type PropsWithChildren,
  type SetStateAction,
  useContext,
  useState,
} from 'react';

interface NavMenuContextProps {
  headerHeight: number;
  menuCollapsed: boolean;
  menuWidth: string | number;
  setHeaderHeight: Dispatch<SetStateAction<number>>;
  setMenuCollapsed: Dispatch<SetStateAction<boolean>>;
  setMenuWidth: Dispatch<SetStateAction<string | number>>;
}

const NavMenuContext = createContext<NavMenuContextProps>({
  headerHeight: 0,
  menuCollapsed: false,
  menuWidth: 0,
  setHeaderHeight: () => null,
  setMenuCollapsed: () => {
    return null;
  },
  setMenuWidth: () => {
    return null;
  },
});

interface Props extends PropsWithChildren {
  initialValue?: boolean;
}

export const NavMenuContextProvider = ({ initialValue, children }: Props) => {
  const [headerHeight, setHeaderHeight] = useState(0);
  const [menuCollapsed, setMenuCollapsed] = useState(initialValue ?? false);
  const [menuWidth, setMenuWidth] = useState<string | number>(0);

  return (
    <NavMenuContext.Provider
      value={{
        headerHeight,
        setHeaderHeight,
        menuCollapsed,
        setMenuCollapsed,
        menuWidth,
        setMenuWidth,
      }}
    >
      {children}
    </NavMenuContext.Provider>
  );
};

export const useNavMenuContext = () => useContext(NavMenuContext);
